export function parseMonthDateFromIso(iso: string) {
  const dateParts = iso.split('T')[0].split('-');
  const year = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10) - 1;
  const day = parseInt(dateParts[2], 10);

  return new Date(year, month, day);
}
